"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initColorSwap(containerEl, swapEl) {
                if (!swapEl)
                    swapEl = containerEl;
                var bgColor = swapEl.style.backgroundColor;
                var color = swapEl.style.color;
                var swapColor = function () {
                    if (swapEl.style.backgroundColor === bgColor) {
                        swapEl.style.backgroundColor = color;
                        swapEl.style.color = bgColor;
                    }
                    else {
                        swapEl.style.backgroundColor = bgColor;
                        swapEl.style.color = color;
                    }
                };
                var disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(containerEl, 'mouseover', swapColor),
                    eXpress.html.addEventListener(containerEl, 'mouseout', swapColor)
                ]);
                return {
                    dispose: function () { return disposableEvents.dispose(); }
                };
            }
            content.initColorSwap = initColorSwap;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createExternalEditor(editorElement, priceElement, deps) {
                var castedEditorElement = editorElement;
                var externalOrder;
                var currentPvc;
                var amount = 1;
                var quantityParam = eXpress.utils.getParameter("quantity", window.location.href, false);
                if (quantityParam)
                    amount = Number(quantityParam);
                var getPrice = deps.getPrice, getPvcByExternalCode = deps.getPvcByExternalCode, addToBasket = deps.addToBasket;
                var countColoredImages = function (text) {
                    var textItems = text.split(';');
                    var regex = new RegExp("^([0-9]{2,})([a-zA-Z])$");
                    return textItems.filter(function (t) { return t !== '*' && regex.test(t) && t.slice(-1).toLowerCase() === 'p'; }).length;
                };
                castedEditorElement.addEventListener("onOrderChanged", function (event) {
                });
                castedEditorElement.onUpdate = function (o) {
                    externalOrder = o;
                    getPvcByExternalCode(o.itemcode).then(function (res) {
                        currentPvc = res;
                        getPrice(currentPvc, amount, countColoredImages(o.telegramtext)).then(function (res) {
                            priceElement.innerHTML = eXpress.utils.getPriceString(res.price.amount, res.price.currency);
                            updatePriceToolTips(res);
                        });
                    });
                };
                var updatePriceToolTips = function (data) {
                    var tooltip = eXpress.html.querySelector(document, '.technical-price-tooltip', false);
                    if (!tooltip)
                        return;
                    var priceContainer = eXpress.html.querySelector(tooltip, '.technical-price-container', true);
                    var priceTemplate = eXpress.html.querySelectorAll(tooltip, '.technical-price-template')[0];
                    priceContainer.innerHTML = "";
                    priceContainer.appendChild(priceTemplate);
                    data.priceItems.forEach(function (item) {
                        if (!item.description && !item.calculationDescription && !item.itemTotal)
                            return;
                        var newCloneFromTemplate = priceTemplate.cloneNode(true);
                        newCloneFromTemplate.style.display = "";
                        var description = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-description', true);
                        item.description ? description.innerHTML = item.description : description.remove();
                        var calculation = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-calculation', true);
                        item.calculationDescription ? calculation.innerHTML = item.calculationDescription : calculation.remove();
                        var result = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-result', true);
                        item.itemTotal ? result.innerHTML = item.itemTotal : result.remove();
                        priceContainer.append(newCloneFromTemplate);
                    });
                };
                document.addEventListener('DOMContentLoaded', function () {
                    castedEditorElement.order = {
                        itemcode: castedEditorElement.dataset["externalcode"] || '',
                        telegramtext: castedEditorElement.dataset["text"] || '',
                    };
                    var priceTooltipEls = eXpress.html.querySelectorAll(document, ".technical-price-tooltip");
                    var tooltips = priceTooltipEls.map(function (tooltip) {
                        return {
                            buttonEl: eXpress.html.querySelector(tooltip, '.technical-price-tooltip-close', true),
                            containerEl: eXpress.html.querySelector(tooltip, '.technical-price-tooltip-collapsible', true)
                        };
                    });
                    tooltips.forEach(components.main.initTooltip);
                    var addToBaskets = document.getElementsByClassName('technical-to-basket');
                    for (var i = 0; i < addToBaskets.length; i++) {
                        addToBaskets[i].classList.remove('u-hide');
                        addToBaskets[i].addEventListener('click', function () {
                            if (externalOrder) {
                                addToBasket(externalOrder.itemcode, externalOrder.telegramtext, amount, countColoredImages(externalOrder.telegramtext));
                            }
                        });
                    }
                });
            }
            content.createExternalEditor = createExternalEditor;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            var Device;
            (function (Device) {
                Device[Device["Desktop"] = 1] = "Desktop";
                Device[Device["Tablet"] = 2] = "Tablet";
                Device[Device["Mobile"] = 3] = "Mobile";
            })(Device = content.Device || (content.Device = {}));
            function createHighlightedTiles(containerEl) {
                var desktopTileEls = eXpress.html.querySelectorAll(containerEl, ".o-highlighted-tiles__tile:not(.hide-on-desktop):not(.u-hide-on-desktop)");
                var tabletTileEls = eXpress.html.querySelectorAll(containerEl, ".o-highlighted-tiles__tile:not(.hide-on-tablet):not(.u-hide-on-tablet)");
                var truncateEls = eXpress.html.querySelectorAll(containerEl, '.technical-shave');
                var tileEl = eXpress.html.querySelectorAll(containerEl, '.o-highlighted-tiles__tile')[0];
                var headerAndTilesEl = eXpress.html.querySelector(containerEl, '.o-highlighted-tiles__header_and_tiles', true);
                var titleEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__title', false);
                var subTitleEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__subtitle', false);
                var textEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__text', false);
                var eventDisposable;
                var currentDevice;
                var getDevice = function () {
                    if (window.innerWidth <= 767) {
                        return Device.Mobile;
                    }
                    else if (window.innerWidth > 768 && window.innerWidth < 960) {
                        return Device.Tablet;
                    }
                    else {
                        return Device.Desktop;
                    }
                };
                var outerHeight = function (el, includeOffset) {
                    if (includeOffset === void 0) { includeOffset = true; }
                    var height = includeOffset ? el.offsetHeight : 0;
                    var style = getComputedStyle(el);
                    height += parseInt(style.marginTop || '0', 10) + parseInt(style.marginBottom || '0', 10);
                    return height;
                };
                var calculateTruncateMaxHeight = function () {
                    var maxHeight = 0;
                    maxHeight = outerHeight(tileEl);
                    titleEl && (maxHeight -= outerHeight(titleEl));
                    subTitleEl && (maxHeight -= outerHeight(subTitleEl));
                    textEl && (maxHeight -= outerHeight(textEl, false));
                    return maxHeight;
                };
                var getTruncateOptions = function () {
                    currentDevice = getDevice();
                    var options = {};
                    switch (currentDevice) {
                        case Device.Desktop:
                            switch (desktopTileEls.length) {
                                case 0:
                                case 3:
                                    options.lines = 3;
                                    options.maxHeight = undefined;
                                    break;
                                default:
                                    options.maxHeight = calculateTruncateMaxHeight();
                                    options.lines = undefined;
                                    break;
                            }
                            break;
                        case Device.Tablet:
                            switch (tabletTileEls.length) {
                                case 1:
                                    options.maxHeight = calculateTruncateMaxHeight();
                                    options.lines = undefined;
                                    break;
                                default:
                                    options.lines = 2;
                                    options.maxHeight = undefined;
                                    break;
                            }
                            break;
                        default:
                            options.lines = 2;
                            options.maxHeight = undefined;
                            break;
                    }
                    return options;
                };
                var onResize = function () {
                    return currentDevice !== getDevice() &&
                        truncatedEls.forEach(function (t) { return t.updateConfig(getTruncateOptions()); });
                };
                var truncatedEls = [];
                var init = function () {
                    truncatedEls = truncateEls.map(function (el) { return content.createTruncate(el, getTruncateOptions()); });
                    eventDisposable = eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(onResize, 250));
                };
                document.documentMode
                    ? eXpress.utils.wait(250).then(function () { return init(); })
                    : init();
                return {
                    dispose: function () {
                        eventDisposable.dispose();
                        truncatedEls.forEach(function (t) { return t.dispose(); });
                    }
                };
            }
            content.createHighlightedTiles = createHighlightedTiles;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            var ProductSlider = (function () {
                function ProductSlider(containerEl, deps) {
                    this.configSquareSlider = {
                        slidesToShow: 6,
                        infinite: false,
                        arrows: false,
                        vertical: false,
                        verticalSwiping: false,
                        slide: '.technical-slideToShow',
                        variableWidth: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 5,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 960,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 415,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            }
                        ]
                    };
                    this.configLandscapeSlider = {
                        slidesToShow: 3,
                        infinite: false,
                        arrows: false,
                        vertical: false,
                        verticalSwiping: false,
                        variableWidth: true,
                        slide: '.technical-slideToShow',
                        responsive: [
                            {
                                breakpoint: 960,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 450,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            }
                        ]
                    };
                    this.sliderEls = eXpress.html.querySelectorAll(containerEl, ".technical-slider");
                    var isMobile = deps.isMobile;
                    this.isMobile = isMobile;
                    this.mobile = this.isMobile();
                    this.docWidth = window.innerWidth;
                    this.ioSlider = this.createIntersectionObserver();
                }
                ProductSlider.prototype.initProductSliders = function () {
                    if (this.sliderEls) {
                        this.setVisibleSlides();
                        var sliders = this.initSliders();
                        if (sliders > 0) {
                            this.addHandlers();
                        }
                    }
                };
                ProductSlider.prototype.setVisibleSlides = function () {
                    var _this = this;
                    this.sliderEls.forEach(function (el) {
                        var technicalSlides = eXpress.html.querySelectorAll(el, ".technical-slide");
                        var technicalSlideElsCount = technicalSlides.length;
                        technicalSlides.forEach(function (slide) { return slide.classList.remove("m-product-slider__slide--center-mobile"); });
                        var hideMobileSlideElsCount = eXpress.html.querySelectorAll(el, ".u-hide-on-mobile-full").length;
                        technicalSlides.forEach(function (slide) {
                            if (_this.mobile && technicalSlideElsCount - hideMobileSlideElsCount === 1 && !slide.classList.contains("u-hide-on-mobile-full"))
                                $(slide).addClass("m-product-slider__slide--center-mobile");
                            if (!slide.classList.contains("technical-slideToShow")) {
                                $(slide).addClass("technical-slideToShow");
                            }
                        });
                    });
                    if (this.mobile) {
                        this.sliderEls.forEach(function (el) {
                            eXpress.html.querySelectorAll(el, ".u-hide-on-mobile-full").forEach(function (slide) { return $(slide).removeClass("technical-slideToShow"); });
                        });
                    }
                    else {
                        this.sliderEls.forEach(function (el) {
                            eXpress.html.querySelectorAll(el, ".u-hide-on-desktop").forEach(function (slide) { return $(slide).removeClass("technical-slideToShow"); });
                        });
                    }
                };
                ProductSlider.prototype.initSliders = function () {
                    var _this = this;
                    var slidersToInit = this.sliderEls
                        .filter(function (el) {
                        return eXpress.html.querySelectorAll(el, ".technical-slideToShow").length >= 2
                            && $(el).data("slider-format") !== undefined;
                    });
                    if (this.ioSlider) {
                        slidersToInit.forEach(function (el) { return _this.ioSlider.observe(el); });
                    }
                    else {
                        slidersToInit.filter(function (el) { return $(el).data("slider-format").toLowerCase() === "square"; }).forEach(function (el) {
                            _this.initSquareSlider(el);
                        });
                        slidersToInit.filter(function (el) { return $(el).data("slider-format").toLowerCase() === "landscape"; }).forEach(function (el) {
                            _this.initLandscapeSlider(el);
                        });
                    }
                    return slidersToInit.length;
                };
                ProductSlider.prototype.initSquareSlider = function (el) {
                    this.initSliderWithConfig(el, this.configSquareSlider);
                };
                ProductSlider.prototype.initLandscapeSlider = function (el) {
                    this.configLandscapeSlider.slidesToShow = $(el).data("slidestoshow");
                    this.initSliderWithConfig(el, this.configLandscapeSlider);
                };
                ProductSlider.prototype.initSliderWithConfig = function (el, config) {
                    $(el).slick(config);
                    this.addEmptySlideToLandscapeSliderIfNeeded(el);
                    this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                    this.addOnAfterChange(el);
                };
                ProductSlider.prototype.createIntersectionObserver = function () {
                    var _this = this;
                    if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        return new IntersectionObserver(function (entries, observer) {
                            entries.forEach(function (entry) {
                                if (entry.isIntersecting) {
                                    if ($(entry.target).data("slider-format").toLowerCase() === "square")
                                        _this.initSquareSlider(entry.target);
                                    if ($(entry.target).data("slider-format").toLowerCase() === "landscape")
                                        _this.initLandscapeSlider(entry.target);
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { rootMargin: "0px 0px 0px 0px" });
                    }
                };
                ProductSlider.prototype.addEmptySlideToLandscapeSliderIfNeeded = function (slider) {
                    var parent = eXpress.html.getParentWithClassName(slider, "m-product-slider");
                    if (parent) {
                        var slidesToShow = $(slider).slick('slickGetOption', 'slidesToShow');
                        var currentSlideEl = eXpress.html.querySelectorAll(slider, ".slick-slide")[0];
                        var sliderWidth = eXpress.html.querySelector(slider, ".slick-list", true).getBoundingClientRect().width;
                        var slideWidth = currentSlideEl.getBoundingClientRect().width;
                        var slideRightMargin = parseInt(window.getComputedStyle(currentSlideEl).marginRight || "0", 10);
                        var leftOver = sliderWidth - (slideWidth * parseInt(slidesToShow + "" || "1", 10)) - (slideRightMargin * (parseInt(slidesToShow + "" || "1", 10) - 1));
                        var emptySlide = eXpress.html.querySelector(slider, ".technical-empty-slide", false);
                        var shouldAddEmptySlide = leftOver < 0 && Math.abs(leftOver) > slideWidth * 0.1;
                        if (!emptySlide && shouldAddEmptySlide) {
                            $(slider).slick('slickAdd', '<div class="technical-slideToShow technical-empty-slide"></div>');
                        }
                    }
                };
                ProductSlider.prototype.removeEmptySlide = function (slider) {
                    var emptySlide = eXpress.html.querySelector(slider, ".technical-empty-slide", false);
                    var emptySlideIndex = -1;
                    if (emptySlide && emptySlide.dataset && emptySlide.dataset.slickIndex) {
                        emptySlideIndex = +emptySlide.dataset.slickIndex;
                        $(slider).slick('slickRemove', emptySlideIndex);
                    }
                };
                ProductSlider.prototype.onWindowResize = function () {
                    var _this = this;
                    if (window.innerWidth === this.docWidth)
                        return;
                    this.docWidth = window.innerWidth;
                    this.sliderEls.filter(function (el) { return $(el).data("slider-format").toLowerCase() === "landscape" && el.classList.contains("slick-initialized"); }).forEach(function (el) { return _this.removeEmptySlide(el); });
                    if (this.mobile !== this.isMobile()) {
                        this.mobile = this.isMobile();
                        this.setVisibleSlides();
                        this.sliderEls.forEach(function (el) {
                            var visibleSlides = eXpress.html.querySelectorAll(el, ".technical-slideToShow");
                            if (visibleSlides.length < 2 && el.classList.contains("slick-initialized")) {
                                $(el).slick("unslick");
                            }
                            else if (visibleSlides.length >= 2 && el.classList.contains("slick-initialized")) {
                                $(el).slick('resize');
                                $(el).slick('refresh');
                                _this.addEmptySlideToLandscapeSliderIfNeeded(el);
                                _this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                                _this.addOnAfterChange(el);
                            }
                            else {
                                if (_this.ioSlider) {
                                    _this.ioSlider.observe(el);
                                }
                                else {
                                    if ($(el).data("slider-format").toLowerCase() === "square")
                                        _this.initSquareSlider(el);
                                    if ($(el).data("slider-format").toLowerCase() === "landscape")
                                        _this.initLandscapeSlider(el);
                                }
                            }
                        });
                    }
                    else {
                        this.sliderEls.filter(function (el) { return el.classList.contains("slick-initialized"); }).forEach(function (el) {
                            _this.addEmptySlideToLandscapeSliderIfNeeded(el);
                            _this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                        });
                    }
                };
                ProductSlider.prototype.resizeSlidesToHighestWhenFirstSlideImageIsLoaded = function (sliderEl) {
                    var _this = this;
                    var me = this;
                    var classToRemove = this.isMobile() ? 'u-hide-on-mobile-full' : 'u-hide-on-desktop';
                    var slideEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide:not(." + classToRemove + ")");
                    if (slideEls.length === 0)
                        return;
                    var img = eXpress.html.querySelector(slideEls[0], ".technical-slide-imageContainer img", true);
                    if (img.classList.contains("loaded")) {
                        this.resizeSlidesToHighest(sliderEl, slideEls);
                    }
                    else {
                        if ('MutationObserver' in window) {
                            var observer_1 = new MutationObserver(function (mutations) {
                                mutations.forEach(function (mutation) {
                                    if (mutation.attributeName === "class") {
                                        var el = mutation.target;
                                        if (el.classList.contains("loaded")) {
                                            me.resizeSlidesToHighest(sliderEl, slideEls);
                                            observer_1.disconnect();
                                        }
                                    }
                                });
                            });
                            observer_1.observe(img, { attributes: true });
                        }
                        else {
                            if (!img.classList.contains('loaded') && !img.classList.contains('loading')) {
                                if (!img.onload)
                                    img.onload = function () { _this.resizeSlidesToHighest(sliderEl, slideEls); };
                                return;
                            }
                        }
                    }
                };
                ProductSlider.prototype.resizeSlidesToHighest = function (sliderEl, slideEls) {
                    var _this = this;
                    var slideImageHeight = 0;
                    var maxHeightSlideEl = 0;
                    var maxHeightSlideTitleEl = 0;
                    var maxHeightSlideTitleTitleEl = 0;
                    var maxHeightSlideTitleSubTitleEl = 0;
                    var bottomLinkHeight;
                    var imageEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-imageContainer img");
                    imageEls.forEach(function (imgEl) {
                        if (imgEl.classList.contains('loaded')) {
                            _this.removeAspectRatio(imgEl);
                        }
                        else {
                            if (!imgEl.onload)
                                imgEl.onload = function () { _this.removeAspectRatio(imgEl); };
                        }
                    });
                    slideEls.forEach(function (slideEl) {
                        var titleEl = eXpress.html.querySelector(slideEl, ".technical-slide-title", false);
                        if (slideEl.style.removeProperty) {
                            slideEl.style.removeProperty("height");
                            if (titleEl)
                                titleEl.style.removeProperty("height");
                        }
                        else {
                            slideEl.style.height = '';
                            if (titleEl)
                                titleEl.style.height = '';
                        }
                    });
                    slideEls.forEach(function (slideEl) {
                        if (!eXpress.html.isElementVisible(slideEl))
                            return;
                        var heightSlideTitleTitleEl = 0;
                        var heightSlideTitleSubTitleEl = 0;
                        var imageContainerEl = eXpress.html.querySelector(slideEl, ".technical-slide-imageContainer", true);
                        var img = eXpress.html.querySelector(imageContainerEl, "img", true);
                        if (slideEls[0] === slideEl && !img.classList.contains('loaded') && !img.classList.contains('loading'))
                            return;
                        var heightSlideTitleEl = 0;
                        var title = eXpress.html.querySelector(slideEl, ".technical-tile-title", false);
                        if (title)
                            heightSlideTitleEl += eXpress.html.getHeightWithMargins(title);
                        var subTitle = eXpress.html.querySelector(slideEl, ".technical-tile-subtitle", false);
                        if (subTitle)
                            heightSlideTitleEl += eXpress.html.getHeightWithMargins(subTitle);
                        var heightSlideEl = slideEl.offsetHeight;
                        if (heightSlideEl > maxHeightSlideEl)
                            maxHeightSlideEl = heightSlideEl;
                        if (heightSlideTitleEl > maxHeightSlideTitleEl)
                            maxHeightSlideTitleEl = heightSlideTitleEl;
                        if (heightSlideTitleTitleEl > maxHeightSlideTitleTitleEl)
                            maxHeightSlideTitleTitleEl = heightSlideTitleTitleEl;
                        if (heightSlideTitleSubTitleEl > maxHeightSlideTitleSubTitleEl)
                            maxHeightSlideTitleSubTitleEl = heightSlideTitleSubTitleEl;
                        if (slideEls[0] === slideEl)
                            slideImageHeight = imageContainerEl.offsetHeight;
                    });
                    slideEls.forEach(function (slideEl) {
                        var titleEl = eXpress.html.querySelector(slideEl, ".technical-slide-title", false);
                        slideEl.style.height = "".concat(maxHeightSlideEl, "px");
                        if (titleEl)
                            titleEl.style.height = "".concat(maxHeightSlideTitleEl, "px");
                    });
                    bottomLinkHeight = maxHeightSlideEl - (maxHeightSlideTitleEl + slideImageHeight);
                    if (bottomLinkHeight < 0)
                        bottomLinkHeight = 0;
                    var bottomValue = (bottomLinkHeight + (slideImageHeight / 2)) - 14;
                    this.setPositionButtons(sliderEl, bottomValue);
                };
                ProductSlider.prototype.removeAspectRatio = function (imageEl) {
                    var imgContainerEl = eXpress.html.getParentWithClassName(imageEl, "technical-slide-imageContainer");
                    if (imgContainerEl)
                        imgContainerEl.style.removeProperty("--aspect-ratio");
                };
                ProductSlider.prototype.setPositionButtons = function (sliderEl, bottomValue) {
                    if (!sliderEl)
                        return;
                    var arrows = $(sliderEl).slick("slickGetOption", "arrows");
                    if (!arrows) {
                        var prevButtonString = '<button class="a-button a-button--disabled a-button--slider-button m-product-slider__button--prev icon-arrow-left technical-slide-button" style="bottom:' + bottomValue + 'px" aria-label="Previous"></button>';
                        var nextButtonString = '<button class="a-button a-button--slider-button m-product-slider__button--next icon-arrow-right technical-slide-button" style="bottom:' + bottomValue + 'px" aria-label="Next"></button>';
                        $(sliderEl).slick("slickSetOption", {
                            arrows: true,
                            prevArrow: prevButtonString,
                            nextArrow: nextButtonString,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 960,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 600,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 450,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 415,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                }
                            ]
                        }, false);
                        $(sliderEl).slick('refresh');
                    }
                    else {
                        var buttonsEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-button");
                        buttonsEls.forEach(function (sliderButtonEl) {
                            sliderButtonEl.style.bottom = "".concat(bottomValue, "px");
                        });
                    }
                };
                ProductSlider.prototype.addOnAfterChange = function (sliderEl) {
                    $(sliderEl).on("afterChange", function (event, slick, currentSlide) {
                        var buttonsEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-button");
                        buttonsEls.forEach(function (buttonEl) {
                            if (buttonEl.classList.contains("slick-disabled") && !buttonEl.classList.contains("a-button--disabled"))
                                buttonEl.classList.add("a-button--disabled");
                            else
                                buttonEl.classList.remove("a-button--disabled");
                        });
                    });
                };
                ProductSlider.prototype.addHandlers = function () {
                    window.addEventListener('resize', eXpress.utils.debounce(this.onWindowResize.bind(this), 250));
                };
                return ProductSlider;
            }());
            content.ProductSlider = ProductSlider;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBar(containerEl, dependencies) {
                var onClick = dependencies.onClick, clearActiveBar = dependencies.clearActiveBar;
                var barEl = eXpress.html.querySelector(containerEl, ".m-review-bars__review-bar", true);
                var quantityEl = eXpress.html.querySelector(containerEl, ".m-review-bars__reviews-quantity", true);
                var enabledClass = "m-review-bars__review-link";
                var disabledClass = "m-review-bars__review-no-link";
                var activeClass = "m-review-bars__review-link--active";
                var startValue = 0;
                var isEnabled = function () { return containerEl.classList.contains(enabledClass); };
                var isDisabled = function () { return containerEl.classList.contains(disabledClass); };
                function getStartValue() {
                    return +(containerEl.getAttribute('data-star-value') || 0);
                }
                var onClickEvent = function () {
                    clearActiveBar();
                    containerEl.classList.add(activeClass);
                    onClick(startValue);
                };
                var enable = function () {
                    if (isDisabled())
                        containerEl.classList.remove(disabledClass);
                    containerEl.classList.add(enabledClass);
                    containerEl.addEventListener("click", onClickEvent);
                };
                var updateBarPercentage = function (totalNumberOfReviews, starAmount) {
                    var barActiveEl = eXpress.html.querySelector(barEl, ".m-review-bars__review-bar-active", true);
                    var percentage = totalNumberOfReviews > 0 ? starAmount * 100 / totalNumberOfReviews : 0;
                    barActiveEl.style.width = percentage + "%";
                };
                var disable = function () {
                    if (isEnabled())
                        containerEl.classList.remove(enabledClass);
                    containerEl.classList.add(disabledClass);
                    containerEl.removeEventListener("click", onClickEvent);
                };
                var update = function (totalNumberOfReviews, amount) {
                    quantityEl.innerHTML = amount + "";
                    updateBarPercentage(totalNumberOfReviews, amount);
                    if (amount > 0 && isDisabled())
                        enable();
                    if (amount === 0 && isEnabled())
                        disable();
                };
                var init = function () {
                    deInit();
                    startValue = getStartValue();
                    if (isEnabled())
                        containerEl.addEventListener("click", onClickEvent);
                };
                var deInit = function () {
                    if (isEnabled())
                        containerEl.removeEventListener("click", onClickEvent);
                };
                var dispose = function () {
                    deInit();
                };
                init();
                return {
                    dispose: dispose,
                    update: update,
                    startValue: startValue
                };
            }
            content.createReviewBar = createReviewBar;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBars(containerEl, dependencies) {
                var eventDisposable;
                var onClick = dependencies.onClick;
                var reviewBarEls = eXpress.html.querySelectorAll(containerEl, '.m-review-bars__review-link, .m-review-bars__review-no-link');
                var reviewBarComponents = [];
                var reviewBarsTotalLinkEl = eXpress.html.querySelector(containerEl, '.m-review-bars__reviews-link', true);
                var clearActiveBar = function () { return reviewBarEls.forEach(function (el) { return eXpress.html.removeClass(el, 'm-review-bars__review-link--active'); }); };
                var deinit = function () { return eventDisposable && eventDisposable.dispose(); };
                var updateAmounts = function (totalReviews, starAmounts, resetActiveBar) {
                    if (resetActiveBar === void 0) { resetActiveBar = false; }
                    var replaceAmountBetweenParentheses = function (text, amount) {
                        return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
                    };
                    if (resetActiveBar)
                        clearActiveBar();
                    reviewBarComponents.forEach(function (barcomponent) {
                        var reviewStar = starAmounts.find(function (x) { return x.key === barcomponent.startValue; });
                        barcomponent.update(totalReviews, !reviewStar ? 0 : reviewStar.value);
                    });
                    var innerTextEl = eXpress.html.querySelector(reviewBarsTotalLinkEl, 'span', true);
                    innerTextEl.innerText = replaceAmountBetweenParentheses(innerTextEl.innerText, totalReviews + "");
                };
                var init = function () {
                    deinit();
                    reviewBarEls.forEach(function (el) {
                        reviewBarComponents.push(content.createReviewBar(el, { onClick: onClick, clearActiveBar: clearActiveBar }));
                    });
                    eventDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(reviewBarsTotalLinkEl, "click", function () {
                            onClick(0);
                            clearActiveBar();
                        }),
                    ]);
                };
                var dispose = function () {
                    deinit();
                };
                init();
                return {
                    dispose: dispose,
                    updateAmounts: updateAmounts
                };
            }
            content.createReviewBars = createReviewBars;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createShowMoreButton(containerEl, options) {
                var onClick = function () { return options.onClick(); };
                var enable = function () {
                    var buttonEl = eXpress.html.querySelector(containerEl, ".a-button");
                    containerEl.removeEventListener("click", onClick);
                    containerEl.addEventListener("click", onClick);
                    if (buttonEl)
                        buttonEl.classList.add("a-button--active");
                };
                var disable = function () {
                    containerEl.removeEventListener("click", onClick);
                };
                var show = function () {
                    containerEl.style.display = '';
                };
                var hide = function () {
                    containerEl.style.display = 'none';
                };
                var dispose = function () {
                    disable();
                };
                enable();
                return {
                    show: show,
                    hide: hide,
                    enable: enable,
                    disable: disable,
                    dispose: dispose,
                };
            }
            content.createShowMoreButton = createShowMoreButton;
            function createPaginationControl(containerEl, options) {
                var buttonTemplateEl = containerEl.querySelector(".m-review-blocks-controls__button");
                var leftControlEL = buttonTemplateEl.cloneNode(true);
                eXpress.html.querySelector(leftControlEL, 'button', true)
                    .className += " icon-arrow-left m-review-blocks-controls__pagination-button";
                eXpress.html.hide(leftControlEL);
                var rightControlEL = buttonTemplateEl.cloneNode(true);
                eXpress.html.querySelector(rightControlEL, 'button', true)
                    .className += " icon-arrow-right m-review-blocks-controls__pagination-button";
                eXpress.html.hide(rightControlEL);
                var reviewBlocksControlEl = document.getElementsByClassName('m-review-blocks-controls');
                reviewBlocksControlEl[1].insertAdjacentElement('afterbegin', leftControlEL);
                reviewBlocksControlEl[1].insertAdjacentElement('beforeend', rightControlEL);
                eXpress.html.remove(buttonTemplateEl);
                var numberedButtonEls = [];
                var amountOfPagesToShow = parseInt(containerEl.getAttribute('data-amount-of-pages'), 10) || 5;
                var numberOfPages = options.numberOfPages;
                var indexOffset = 0;
                var selectedPage;
                var onNumberedButtonClicked = function (e) {
                    var buttonEl = e.currentTarget;
                    options.onClick(parseInt(buttonEl.textContent, 10));
                };
                var showArrowControl = function (show, el) {
                    if (show) {
                        eXpress.html.show(el);
                        el.removeEventListener("click", onClickArrowControl);
                        el.addEventListener("click", onClickArrowControl);
                    }
                    else {
                        eXpress.html.hide(el);
                        el.removeEventListener("click", onClickArrowControl);
                    }
                };
                var updatePaginations = function (pages, pageNumber) {
                    if (pageNumber) {
                        if (pageNumber === 1)
                            indexOffset = 0;
                        selectedPage = pageNumber;
                    }
                    if (pages)
                        numberOfPages = pages;
                    numberedButtonEls = [];
                    eXpress.html.querySelectorAll(containerEl, ".m-review-blocks-controls__button.numbered-control")
                        .forEach(eXpress.html.remove);
                    var indexCondition = Math.min((numberOfPages + 1), (amountOfPagesToShow + 1 + indexOffset));
                    for (var index = 1 + indexOffset; index < indexCondition; index++) {
                        var buttonCloneEl = buttonTemplateEl.cloneNode(true);
                        buttonCloneEl.classList.add('numbered-control');
                        if (selectedPage === index) {
                            var activeButtonEl = eXpress.html.querySelector(buttonCloneEl, ".a-button");
                            if (activeButtonEl)
                                activeButtonEl.classList.add("a-button--active");
                        }
                        else {
                            buttonCloneEl.addEventListener("click", onNumberedButtonClicked);
                        }
                        eXpress.html.querySelector(buttonCloneEl, '.a-button--review', true)
                            .insertAdjacentText('beforeend', index.toString());
                        numberedButtonEls.push(buttonCloneEl);
                    }
                    var docFrag = document.createDocumentFragment();
                    docFrag.append.apply(docFrag, numberedButtonEls);
                    rightControlEL.parentNode.insertBefore(docFrag, rightControlEL);
                    toggleArrowControls();
                };
                var toggleArrowControls = function () {
                    showArrowControl((amountOfPagesToShow + indexOffset) < numberOfPages, rightControlEL);
                    showArrowControl((indexOffset - amountOfPagesToShow) >= 0, leftControlEL);
                };
                var onClickArrowControl = function (e) {
                    var controlEl = e.currentTarget;
                    var isLeft = controlEl.querySelector('.icon-arrow-left');
                    if (isLeft)
                        indexOffset -= amountOfPagesToShow;
                    else
                        indexOffset += amountOfPagesToShow;
                    updatePaginations();
                };
                updatePaginations(numberOfPages, 1);
                return {
                    updatePaginations: updatePaginations,
                    dispose: function () {
                        leftControlEL.removeEventListener("click", onClickArrowControl);
                        rightControlEL.removeEventListener("click", onClickArrowControl);
                        numberedButtonEls.forEach(function (e) { return e.removeEventListener("click", onNumberedButtonClicked); });
                    }
                };
            }
            content.createPaginationControl = createPaginationControl;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBlocks(containerEl, options) {
                var productReviewsNameLabel = options.productReviewsNameLabel, _a = options.productReviewsAnonymousLabel, productReviewsAnonymousLabel = _a === void 0 ? "Anonymous" : _a;
                var reviewTemplateEl = eXpress.html.querySelector(containerEl, '.m-review-block.template', true);
                eXpress.html.remove(reviewTemplateEl);
                var createUserReview = function (review) {
                    var reviewTemplateCloneEl = reviewTemplateEl.cloneNode(true);
                    var reviewStarsEl = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__stars", true);
                    var fullStarsEl = eXpress.html.querySelector(reviewStarsEl, ".a-review-stars__full", true);
                    fullStarsEl.style.width = "".concat(review.score * 100 / 5, "%");
                    if (review.comment)
                        eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__review", true)
                            .insertAdjacentText('beforeend', review.comment);
                    var reviewerBlockEL = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__reviewer", true);
                    if (productReviewsNameLabel) {
                        var name_1 = "".concat(review.firstName || "", " ").concat(review.lastName || "");
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__reviewer-name", true)
                            .insertAdjacentText('beforeend', "".concat(productReviewsNameLabel.replace('{0}', name_1.trim() || productReviewsAnonymousLabel)));
                    }
                    else {
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__reviewer-name", true).style.display = 'none';
                    }
                    if (review.reviewDate)
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__review-date", true)
                            .insertAdjacentText('beforeend', review.reviewDate);
                    var commentBlockEl = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__answer-block", true);
                    if (review.feedback && review.feedbackDate) {
                        eXpress.html.querySelector(commentBlockEl, ".m-review-blocks__answer-block__answer-date", true)
                            .insertAdjacentText('beforeend', review.feedbackDate);
                        eXpress.html.querySelector(commentBlockEl, ".m-review-blocks__answer-block__answer", true)
                            .insertAdjacentHTML("beforeend", "<span>".concat(review.feedback, "</span>"));
                    }
                    else {
                        eXpress.html.remove(commentBlockEl);
                    }
                    eXpress.html.show(reviewTemplateCloneEl);
                    return reviewTemplateCloneEl;
                };
                var addReviews = function (productCategoryReviews, replace) {
                    if (replace === void 0) { replace = false; }
                    var reviewEls = productCategoryReviews.map(function (r) { return createUserReview(r); });
                    if (replace)
                        clear();
                    containerEl.append.apply(containerEl, reviewEls);
                };
                var clear = function () { return containerEl.innerHTML = ''; };
                return {
                    addReviews: addReviews,
                    clear: clear,
                };
            }
            content.createReviewBlocks = createReviewBlocks;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewLanguageSelect(containerEl, dependencies) {
                var eventDisposable;
                var onSelect = dependencies.onSelect;
                var languageSelectEl = eXpress.html.querySelector(containerEl, ".technical-review-language-selector", true);
                var deInit = function () { return eventDisposable && eventDisposable.dispose(); };
                var init = function () {
                    deInit();
                    eventDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(languageSelectEl, "change", function () {
                            onSelect(languageSelectEl.value);
                        }),
                    ]);
                };
                var dispose = function () {
                    deInit();
                };
                function selectedLanguage() {
                    return languageSelectEl.value;
                }
                var updateAmounts = function (reviewAmounts) {
                    var totalReviews = 0;
                    var languagesCount = 0;
                    var replaceAmountBetweenParentheses = function (text, amount) {
                        return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
                    };
                    [].slice.call(languageSelectEl.options).forEach(function (o) {
                        var option = o;
                        if (option.value === "all") {
                            totalReviews = reviewAmounts.filter(function (r) { return r.key === option.value; })[0].value;
                            option.text = replaceAmountBetweenParentheses(option.text, totalReviews + "");
                        }
                        else if (option.value !== "other" && option.value !== "all") {
                            var languageCount = reviewAmounts.filter(function (r) { return r.key === option.value; })[0].value;
                            languagesCount += languageCount;
                            option.text = replaceAmountBetweenParentheses(option.text, languageCount + "");
                        }
                        else if (option.value === "other") {
                            option.text = replaceAmountBetweenParentheses(option.text, (totalReviews - languagesCount) + "");
                        }
                    });
                };
                init();
                return {
                    dispose: dispose,
                    updateAmounts: updateAmounts,
                    selectedLanguage: selectedLanguage
                };
            }
            content.createReviewLanguageSelect = createReviewLanguageSelect;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initShowMoreElements(containerEl, buttonEl, parameter, elementselector) {
                var elementElsDesktop = eXpress.html.querySelectorAll(containerEl, (elementselector ? elementselector : '.technical-showmore') + '.u-hide-on-desktop-full');
                var elementElsMobile = eXpress.html.querySelectorAll(containerEl, (elementselector ? elementselector : '.technical-showmore') + '.u-hide-on-mobile-full');
                var batchsizeDesktop = parseInt(buttonEl.dataset['batchsizeDesktop'] || '999', 10);
                var batchsizeMobile = parseInt(buttonEl.dataset['batchsizeMobile'] || '999', 10);
                var currentPage = parseInt(buttonEl.dataset.currentpage || '0', 0);
                if (elementElsDesktop.length === 0 && elementElsMobile.length === 0)
                    return;
                var showElements = function (sizeMobile, sizeDesktop) {
                    var toShowDesktop = elementElsDesktop.splice(0, sizeDesktop);
                    toShowDesktop.forEach(function (e) { return e.classList.remove('u-hide-on-desktop-full'); });
                    if (elementElsDesktop.length === 0) {
                        if (buttonEl.parentElement && !buttonEl.classList.contains('technical-no-hide-parrent'))
                            buttonEl.parentElement.classList.add('u-hide-on-desktop-full');
                        else
                            buttonEl.classList.add('u-hide-on-desktop-full');
                    }
                    var toShowMobile = elementElsMobile.splice(0, sizeMobile);
                    toShowMobile.forEach(function (e) { return e.classList.remove('u-hide-on-mobile-full'); });
                    if (elementElsMobile.length === 0) {
                        if (buttonEl.parentElement && !buttonEl.classList.contains('technical-no-hide-parrent'))
                            buttonEl.parentElement.classList.add('u-hide-on-mobile-full');
                        else
                            buttonEl.classList.add('u-hide-on-mobile-full');
                    }
                };
                var showMore = function () {
                    currentPage = currentPage + 1;
                    buttonEl.dataset.currentpage = currentPage.toString();
                    var url = location.href;
                    url = eXpress.utils.updateParameter(parameter ? parameter : "currentpage", buttonEl.dataset.currentpage, url);
                    history.replaceState(null, '', url.toLowerCase());
                    showElements(batchsizeMobile, batchsizeDesktop);
                };
                var disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(buttonEl, 'click', showMore)
                ]);
                return {
                    dispose: function () { return disposableEvents.dispose(); }
                };
            }
            content.initShowMoreElements = initShowMoreElements;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createTruncate(containerEl, opts) {
                var lineHeight = Math.ceil(opts.lineHeight ? opts.lineHeight : parseFloat(window.getComputedStyle(containerEl).lineHeight || "0"));
                var lines = Math.ceil(opts.lines ? opts.lines : 1);
                var maxHeight = Math.ceil(opts.maxHeight ? opts.maxHeight : lineHeight * lines);
                var defaults = {
                    ellipsis: '\u2026 ',
                    showMore: $('.technical-shave-more')[0].outerHTML,
                    showLess: $('.technical-shave-less')[0].outerHTML,
                    lineHeight: lineHeight,
                    lines: lines,
                    maxHeight: maxHeight < lineHeight ? lineHeight : maxHeight
                };
                if (eXpress.html.hasClass(containerEl, "truncate-loading-1-line"))
                    eXpress.html.removeClass(containerEl, "truncate-loading-1-line");
                if (eXpress.html.hasClass(containerEl, "truncate-loading-5-lines--pcp"))
                    eXpress.html.removeClass(containerEl, "truncate-loading-5-lines--pcp");
                var $containerEl = $(containerEl);
                var onClick = function (ev) {
                    var currentEl = ev.target;
                    if (currentEl.classList.contains("technical-shave-more")) {
                        if (opts.eventTrackingMethod && opts.openEventAction)
                            opts.eventTrackingMethod(opts.openEventAction);
                        $containerEl.truncate('expand');
                    }
                    else if (currentEl.classList.contains("technical-shave-less")) {
                        if (opts.eventTrackingMethod && opts.closeEventAction)
                            opts.eventTrackingMethod(opts.closeEventAction);
                        $containerEl.truncate('collapse');
                        containerEl.scrollIntoView();
                    }
                };
                var updateConfig = function (newOpts) {
                    $containerEl.truncate('config', __assign(__assign({}, newOpts), defaults));
                    $containerEl.truncate('collapse');
                };
                var updateContent = function (html) {
                    $containerEl.truncate('update', html);
                    $containerEl.truncate('collapse');
                };
                var collapse = function () {
                    $containerEl.truncate('collapse');
                };
                $containerEl.truncate(__assign(__assign({}, opts), defaults));
                containerEl.addEventListener('click', onClick);
                return {
                    dispose: function () { return containerEl.removeEventListener('click', onClick); },
                    updateConfig: updateConfig,
                    updateContent: updateContent,
                    collapse: collapse
                };
            }
            content.createTruncate = createTruncate;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createUserReviews(containerEl, deps, options) {
                var getReviewsAsync = deps.getReviewsAsync;
                var totalAmountOfReviews = deps.totalAmountOfReviews;
                var _a = options.numberOfReviewsToShow, numberOfReviewsToShow = _a === void 0 ? 5 : _a, _b = options.startPageOffset, startPageOffset = _b === void 0 ? 0 : _b;
                var _c = options.showLoadMoreButton, showLoadMoreButton = _c === void 0 ? true : _c;
                var productReviewsNameLabel = options.productReviewsNameLabel, productReviewsAnonymousLabel = options.productReviewsAnonymousLabel;
                var pageNumber = 0 + startPageOffset;
                var activeFilter = undefined;
                var activeLanguage = undefined;
                var reviewLanguageSelect;
                var reviewBlocksComponent = components.content.createReviewBlocks(eXpress.html.querySelector(containerEl, '.m-review-blocks', true), {
                    productReviewsNameLabel: productReviewsNameLabel,
                    productReviewsAnonymousLabel: productReviewsAnonymousLabel
                });
                var mobileControlEl = eXpress.html.querySelector(containerEl, '.m-review-blocks-controls.u-hide-on-desktop-full', true);
                var desktopControlEl = eXpress.html.querySelector(containerEl, '.m-review-blocks-controls.u-hide-on-mobile-full', true);
                var numberOfPages = Math.ceil(totalAmountOfReviews / numberOfReviewsToShow);
                var loadNextPage = function (page, filter, language, reset) {
                    if (reset === void 0) { reset = false; }
                    pageNumber++;
                    var activeLanguageChanged = false;
                    if (reset) {
                        pageNumber = 1;
                        showLoadMoreButton = true;
                        loadMoreButtonComponent.show();
                        loadMoreButtonComponent.enable();
                    }
                    if (page)
                        pageNumber = page;
                    if (filter !== undefined)
                        activeFilter = filter;
                    if (language !== undefined) {
                        activeLanguageChanged = activeLanguage !== language;
                        if (activeLanguageChanged)
                            activeFilter = undefined;
                        activeLanguage = language;
                    }
                    else {
                        if (reviewLanguageSelect && reviewLanguageSelect.selectedLanguage) {
                            activeLanguage = reviewLanguageSelect.selectedLanguage;
                        }
                    }
                    loadMoreButtonComponent.disable();
                    getReviewsAsync(pageNumber, activeFilter, activeLanguage)
                        .then(function (res) {
                        var reviews = res.productCategoryReviews;
                        reviewBlocksComponent.addReviews(reviews, reset);
                        totalAmountOfReviews = res.totalAmountOfReviews;
                        showLoadMoreButton = totalAmountOfReviews >= pageNumber * numberOfReviewsToShow;
                        if (reviewBarsComponent && res.starAmounts) {
                            reviewBarsComponent.updateAmounts(res.totalAmountOfReviews, res.starAmounts, activeLanguageChanged);
                            if (activeFilter) {
                                var filteredAmount = res.starAmounts.filter(function (a) { return a.key === activeFilter; })[0];
                                if (filteredAmount) {
                                    totalAmountOfReviews = filteredAmount.value;
                                    showLoadMoreButton = totalAmountOfReviews >= pageNumber * numberOfReviewsToShow;
                                }
                            }
                        }
                    })
                        .always(function () {
                        if (!showLoadMoreButton) {
                            loadMoreButtonComponent.hide();
                            loadMoreButtonComponent.disable();
                        }
                        else
                            loadMoreButtonComponent.enable();
                        paginationControlComponent.updatePaginations(Math.ceil(totalAmountOfReviews / numberOfReviewsToShow), pageNumber);
                    });
                };
                var paginationControlComponent = components.content.createPaginationControl(desktopControlEl, {
                    numberOfPages: numberOfPages,
                    onClick: function (page) { return loadNextPage(page, undefined, undefined, true); },
                });
                var loadMoreButtonComponent = components.content.createShowMoreButton(mobileControlEl, {
                    onClick: loadNextPage,
                });
                var reviewBarsComponent = components.content.createReviewBars(eXpress.html.querySelector(containerEl, '.m-review-bars', true), {
                    onClick: function (filter) { return loadNextPage(undefined, filter, undefined, true); }
                });
                var languageSelectorContainerEl = eXpress.html.querySelector(containerEl, '.technical-review-language-selector-container', false);
                if (languageSelectorContainerEl)
                    reviewLanguageSelect = components.content.createReviewLanguageSelect(languageSelectorContainerEl, {
                        onSelect: function (lang) { return loadNextPage(undefined, undefined, lang, true); }
                    });
                if (!showLoadMoreButton) {
                    loadMoreButtonComponent.hide();
                }
                var isMobileControl = function () { return !eXpress.html.isElementVisible(desktopControlEl); };
                var isMobile = isMobileControl();
                var onWindowResize = function () {
                    var isMobileOnResize = isMobileControl();
                    if (isMobile !== isMobileOnResize) {
                        loadNextPage(1, activeFilter, activeLanguage, true);
                        isMobile = isMobileOnResize;
                    }
                };
                window.addEventListener('resize', onWindowResize);
                return {
                    dispose: function () { return window.removeEventListener('resize', onWindowResize); },
                };
            }
            content.createUserReviews = createUserReviews;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createUsps(containerEl) {
                var iconEls = eXpress.html.querySelectorAll(containerEl, '.m-usp__icon');
                var icons = {};
                eXpress.utils.getInlineSvgsAsync(iconEls
                    .filter(function (el) { return !!el.getAttribute('data-icon-url'); })
                    .map(function (el) { return el.getAttribute('data-icon-url'); }))
                    .then(function (res) {
                    res.forEach(function (icon) { return icons[icon.url] = icon.svg; });
                    iconEls.forEach(function (el) {
                        var icon = icons[el.getAttribute('data-icon-url').replace("Icon.", "").toLowerCase()];
                        icon && el.insertAdjacentHTML("beforeend", icon);
                    });
                });
            }
            content.createUsps = createUsps;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initVideoPlayer(videoContainerEl, autoplayOnClick) {
                if (autoplayOnClick === void 0) { autoplayOnClick = true; }
                var playerEl = eXpress.html.querySelector(videoContainerEl, '.technical-video-frame', true);
                var overlayEl = eXpress.html.querySelector(videoContainerEl, '.technical-video-overlay', false);
                var onOverlayClick = function (ev) {
                    ev.preventDefault();
                    if (playerEl.src.toLowerCase().indexOf('youtube') > -1) {
                        hideOverlay();
                        playPauseYoutubeVideo('play');
                    }
                    if (playerEl.src.toLowerCase().indexOf('vimeo') > -1) {
                        var param = eXpress.utils.getParameter('autoplay', playerEl.src.toLowerCase());
                        if (!param)
                            if (playerEl.src.indexOf('?') > -1)
                                playerEl.src = playerEl.src + '&autoplay=1';
                            else
                                playerEl.src = playerEl.src + '?autoplay=1';
                        else
                            eXpress.utils.updateParameter('autoplay', '1', playerEl.src.toLowerCase());
                        hideOverlay();
                    }
                };
                var playPauseYoutubeVideo = function (action) {
                    if (action === "play") {
                        hideOverlay();
                        postMessageToPlayer({
                            "event": "command",
                            "func": "playVideo",
                        });
                    }
                    else {
                        showOverlay();
                        postMessageToPlayer({
                            "event": "command",
                            "func": "pauseVideo",
                        });
                    }
                };
                var hideOverlay = function () {
                    if (overlayEl)
                        overlayEl.classList.add("u-hide");
                };
                var showOverlay = function () {
                    if (overlayEl)
                        overlayEl.classList.remove("u-hide");
                };
                var postMessageToPlayer = function (command) {
                    if (playerEl && playerEl.contentWindow) {
                        playerEl.contentWindow.postMessage(JSON.stringify(command), "*");
                    }
                };
                var init = function () {
                    if (overlayEl && autoplayOnClick)
                        eXpress.html.addEventListener(overlayEl, 'click', onOverlayClick);
                };
                init();
                return {
                    dispose: function () { if (overlayEl)
                        eXpress.html.addEventListener(overlayEl, 'click', onOverlayClick); },
                    playPauseYoutubeVideo: function (action) { return playPauseYoutubeVideo(action); },
                    showOverlay: showOverlay,
                    isOverlayVisible: function () {
                        return overlayEl && !overlayEl.classList.contains("u-hide");
                    }
                };
            }
            content.initVideoPlayer = initVideoPlayer;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
